import { createTheme } from "@mui/material";
import { ptBR } from '@mui/x-data-grid/locales';
import { ptBR as pickersPtBR } from '@mui/x-date-pickers/locales';
import { ptBR as corePtBR } from '@mui/material/locale';

const theme = createTheme(
	{
		palette: {
			type: 'light',
			primary: {
			main: '#3f51b5',
			},
			secondary: {
			main: '#f50057',
			},
			// text: {
			// primary: '#3f51b5',
			// secondary: 'rgb(44, 56, 126)',
			// disabled: 'rgb(101, 115, 195)',
			// hint: '#3f51b5',
			// },
		},
		typography: {
			fontFamily: 'Mulish',
			fontSize: 12,
			h1: {
			fontSize: '4rem',
			},
			h2: {
			fontSize: '3.5rem',
			},
			h3: {
			fontSize: '2.5rem',
			},
			h4: {
			fontSize: '2rem',
			},
		},  
	},
	ptBR, 										// Traduz textos do React MUI datagrid
	pickersPtBR,								// Traduz textos dos date pickers do React MUI
	corePtBR
)

export default theme